import { logger } from 'shared/lib'
import type { IParamsFiltersList } from 'entities/Broadcast/api/types'
import { Segment } from 'entities/Segment/model/Segment'
import { TagsApi } from 'entities/Tags'
import { Tag } from 'entities/Tags/model/Tag'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import type { IEnrollmentFiltersParams } from 'widgets/ContactEnrollment/types/types'

export const initEnrollmentFilters = async (
  entities: IEntitiesStore,
  filters?: IParamsFiltersList | null
): Promise<Partial<IEnrollmentFiltersParams> | undefined> => {
  if (!filters) return

  try {
    const tagsIds = filters.tags || []
    const contactsIds = filters.contacts || []
    const segmentsIds = filters.segments || []

    const [tags, contacts] = await Promise.all([
      TagsApi.getTagsById(tagsIds).then((tags) => tags.map((tag) => new Tag(tag))),
      entities.contactsStore.getByIds(contactsIds),
    ])
    const segments = segmentsIds.reduce<Segment[]>((state, id) => {
      const item = entities.segmentsStore.getItem(id)

      if (item) {
        state.push(item)
      }

      return state
    }, [])
    const advanced = filters.advanced?.map(
      (item) =>
        new Segment({
          id: -1,
          organization_id: 0,
          name: '',
          filters: item,
          is_favorite: false,
        })
    )

    return {
      tags: tags,
      segments: segments,
      contacts: contacts,
      filters: advanced,
    }
  } catch (e) {
    logger.error(e)
  }
}
